// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"4b29f07c","79":"4b29f07c","266":"4b29f07c","504":"4b29f07c","537":"4b29f07c","897":"4b29f07c","977":"4b29f07c"}[chunkId] + ".chunk.css";
};